import '@/feature-flags' // This must be FIRST import
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vee-validate.config.js'
import createI18nInstance from './plugins/i18n/index.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'vue-loading-overlay/dist/css/index.css'
import '../node_modules/vue3-form-wizard/dist/style.css'
import 'vue-multiselect-next/dist/vue-multiselect.min.css'
import '@/assets/sass/custom.scss'
// @ts-ignore
import Autocomplete from '@trevoreyre/autocomplete-vue'
// @ts-ignore
import Vue3Clipboard from 'vue3-clipboard'
// @ts-ignore
import VueFormWizard from 'vue3-form-wizard'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import filters from '@/filters'
import DynamicModal from '@/components/utilities/modal/DynamicModal.vue'
import storage from '@/plugins/storage'
import { initGlobals } from '@/plugins/globals'

// Font Awesome core
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faUser, faUserFriends, faSignOutAlt, faBars, faThLarge, faQrcode, faFolderOpen, faWarehouse, faCircle, faExclamation,
  faInfo, faTimes, faStopwatch, faPencilAlt, faCheck, faComment, faChevronRight, faChevronDown, faChevronUp, faPaperPlane, faPaperclip,
  faFilePdf, faFileVideo, faFileWord, faFileAlt, faSpinner, faSearch, faInfoCircle, faExclamationTriangle, faExclamationCircle, faSort, faSortUp, faSortDown,
  faLightbulb, faTimesCircle, faQuestionCircle, faPrint, faDownload
} from '@fortawesome/free-solid-svg-icons'

import {
  modalManagerPlugin, BModal, BButton, BCard, BSpinner, BListGroup, BListGroupItem, BBadge, BRow, BCol, BLink
} from 'bootstrap-vue-next';

// Vee-validate Rules
import { defineRule } from 'vee-validate'
import { required, min, max, numeric, regex } from '@vee-validate/rules'

// Register validation rules globally
defineRule('required', required)
defineRule('min', min)
defineRule('max', max)
defineRule('numeric', numeric)
defineRule('regex', regex)

// Add icons to the library
library.add(
  faUser, faUserFriends, faSignOutAlt, faBars, faThLarge, faQrcode, faFolderOpen, faWarehouse, faCircle, faExclamation,
  faInfo, faTimes, faStopwatch, faPencilAlt, faCheck, faComment, faChevronRight, faPaperPlane, faPaperclip,
  faFilePdf, faFileVideo, faFileWord, faFileAlt, faSpinner, faSearch, faInfoCircle, faTimesCircle, faQuestionCircle, faExclamationTriangle, faExclamationCircle,
  faChevronDown, faChevronUp, faSort, faSortUp, faSortDown, faLightbulb, faPrint, faDownload
)

// Create app instance
const app = createApp(App)

async function bootstrap() {
  let i18n = null
  try {
    await initGlobals()

    console.log('DEBUG => [bootstrap] Initializing auth state...')
    const authRestored = await store.dispatch('auth/initState') // Restore token and session

    await store.dispatch('serviceRequests/initLookupsFromStorage');

    const profile = store.getters['auth/userProfile'];
    if ((store.state.serviceRequests.scantypes?.length ?? 0) === 0 && profile?.location?.id) {
      await store.dispatch('serviceRequests/getScanTypes', {
        id: profile.location.id,
        isMahle: /* your globals */ require('@/plugins/globals').isMahle()
      });
    }

    i18n = await createI18nInstance()

    if (!authRestored) {
      console.warn('[main.js] => [bootstrap] No valid auth session found.');
      router.replace('/login');
      return;
    }

    // Restore language from storage BEFORE mount
    const savedLang = await storage.local.getItem('SESSION_LANGUAGE')
    if (savedLang) {
      i18n.global.locale.value = savedLang
      store.commit('auth/SET_LANGUAGE', savedLang)
    } else {
      store.commit('auth/SET_LANGUAGE', i18n.global.locale.value)
    }
  } catch (err) {
    console.error('[bootstrap] Failed during init:', err)
    await store.dispatch('auth/clearToken')
  }

  // Tell router "auth is ready"
  store.commit('auth/SET_AUTH_INITIALIZED', true)

  // Apply plugins AFTER state is initialized
  app.use(store)
  app.use(router)
  app.use(i18n)
  app.use(Vue3Clipboard, { autoSetContainer: true, appendToBody: true })
  app.use(VueFormWizard)
  app.use(filters)

  app.use(modalManagerPlugin)

  // Global components
  app.component('Autocomplete', Autocomplete)
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.component('DynamicModal', DynamicModal)

  app.component('BButton', BButton);
  app.component('BModal', BModal);
  app.component('BCard', BCard);
  app.component('BSpinner', BSpinner);
  app.component('BListGroup', BListGroup);
  app.component('BListGroupItem', BListGroupItem);
  app.component('BBadge', BBadge);
  app.component('BRow', BRow);
  app.component('BCol', BCol);
  app.component('BLink', BLink)

  // Mount app
  app.mount('#app')
}

bootstrap()
